import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { Async } from '../../../components/AsyncProvider';
import { Loading } from '../../../components/Loading/index';
import { IAsyncData } from '../../../models';
import { IApplicationState } from '../../../store/models';
import { Container } from '../../Layout/components/Container';
import { getCareers } from '../store/actions';
import { ICareer } from '../store/models';
import { Vacancies } from './Vacanies';

import './index.scss';

export const CareersPage: React.FC = () => {
    const dispatch = useDispatch();

    React.useEffect(
        () => {
            dispatch(getCareers());
        },
        [dispatch]
    );
    const careersBranch = useSelector<IApplicationState, IAsyncData<ICareer>>(state => state.careers.vacancies);

    return (
        <Container>
            <Helmet>
                <title>SCOUT - Careers</title>
            </Helmet>
            <Async
                branch={careersBranch}
                deps={[careersBranch]}
                successRender={(data) => {
                    const { page_content, vacancies } = data;

                    return (
                        <div className="careers">
                            <div className="careers__title">
                                <h1>Careers</h1>
                            </div>
                            <div className="careers__text">
                                <p>{page_content.careers_text}</p>
                            </div>

                            <Vacancies vacancies={vacancies} />
                        </div>
                    );
                }}
                loadingRender={() => <Loading />}
            />
        </Container>
    );
};
